import {Positions} from '../Notification.types';

const TRANSITION_EXIT = {
  duration: 0.2,
  ease: [0.4, 0, 1, 1],
} as const;

export const getAnimationStyle = (position: Positions) => {
  switch (position) {
    case 'bottom-right':
    case 'top-right':
      return {
        initial: {
          x: 50,
          opacity: 0,
        },
        animate: {
          x: 0,
          opacity: 1,
          transition: {
            duration: 0.25,
            opacity: {duration: 0.12},
          },
        },
        exit: {
          x: 100,
          opacity: 0,
          transition: TRANSITION_EXIT,
        },
      };
    case 'bottom-left':
      return {
        initial: {
          x: -100,
          y: 100,
        },
        animate: {
          x: 0,
          y: 100,
        },
        exit: {
          x: -100,
          y: 100,
        },
      };
    case 'top-left':
      return {
        initial: {
          x: -100,
        },
        animate: {
          x: 0,
        },
        exit: {
          x: -100,
        },
      };
    default:
      return {
        initial: {
          x: 100,
        },
        animate: {
          x: 0,
        },
        exit: {
          x: 100,
        },
      };
  }
};
